/**
 * Simple dimension query handler, which returns constant values as estimation of node dimensions.
 */
export class ReactflowDimensionsConstantEstimator {
    static getMinimumWidth() {
        return 224;
    }
    static getDefaultWidth() {
        return 400;
    }
    static getDefaultHeight() {
        return 58;
    }
    getWidth(_estimatedNode) {
        return ReactflowDimensionsConstantEstimator.getDefaultWidth();
    }
    getHeight(_estimatedNode) {
        return ReactflowDimensionsConstantEstimator.getDefaultHeight();
    }
}
//# sourceMappingURL=constant-dimension-estimator.js.map